import { createI18n } from '@common/hooks';
import { useGlobalConfigStore } from '@shared/stores';
import { VueHeadMixin, createHead } from '@unhead/vue';
import { createPinia } from 'pinia';
import PrimeVue from 'primevue/config';
import Tooltip from 'primevue/tooltip';
import { createApp } from 'vue';
import App from './App.vue';
import "./assets/tailwind.css";
import { locales } from './i18n';
import router from './router';

const app = createApp(App);
app
  .use(createPinia())
  .use(createHead())
  .use(createI18n, locales)
  .use(router)
  .use(PrimeVue, {
    theme: 'none'
  })
  .mixin(VueHeadMixin)
  .directive('tooltip', Tooltip);

await useGlobalConfigStore().initializeAsync();

app.mount('#app');

